import { MainBodyDto } from './main-body-dto';
import { PackagingComponentEntryDto } from './packaging-component-entry-dto';

export class MainBodyEntryDto extends PackagingComponentEntryDto {
  packagingVolume?: number;
  underlyingComponent!: MainBodyDto;
}
